import React, { Suspense } from "react";
import { HashRouter as Router, Route, Routes } from "react-router-dom";
import LanguageWrapper from "./LanguageWrapper";

// 懶加載頁面
const PageWrapper = React.lazy(() => import("./page_wrapper/PageWrapper"));
const LoginPage = React.lazy(() => import("./login_page/LoginPage"));
const ResetPasswordPage = React.lazy(() =>
	import("./reset_password_page/ResetPasswordPage")
);
const ResetPasswordSuccessPage = React.lazy(() =>
	import("./reset_password_page/ResetPasswordSuccessPage")
);
const ProductHistoryPage = React.lazy(() =>
	import("./product_history_page/ProductHistoryPage")
);
// === Customer Portal (spec pivot #159 — magic-link only)
// 已拔除：login / set-password / forgot-password / reset-password / profile 5 頁
const CustomerPortalActivate = React.lazy(() =>
	import("./customer_portal/pages/ActivatePage")
);
const CustomerPortalSurveysList = React.lazy(() =>
	import("./customer_portal/pages/SurveysListPage")
);
const CustomerPortalSurveyFill = React.lazy(() =>
	import("./customer_portal/pages/SurveyFillPage")
);
const CustomerPortalSurveyView = React.lazy(() =>
	import("./customer_portal/pages/SurveyViewPage")
);

function App() {
	return (
		<div className="App">
			<LanguageWrapper>
				{/* 懸停效果，用於處理懶加載時的加載動畫或佔位符 */}
				<Suspense fallback={<div>Loading...</div>}>
					<Routes>
						{/* 登入頁面 */}
						<Route path="/:lng" element={<LoginPage />} />
						<Route path="/:lng/login-page" element={<LoginPage />} />
						{/* 頁面框架 */}
						<Route path="/:lng/page-wrapper/*" element={<PageWrapper />} />
						{/* 重設密碼頁面 */}
						<Route
							path="/:lng/reset-password-page/:token"
							element={<ResetPasswordPage />}
						/>
						<Route
							path="/:lng/reset-password-success-page"
							element={<ResetPasswordSuccessPage />}
						/>
						{/* 產品履歷獨立頁面 - 供外部網站使用 */}
						<Route
							path="/:lng/product-history"
							element={<ProductHistoryPage />}
						/>
						<Route
							path="/:lng/product-history/:productId"
							element={<ProductHistoryPage />}
						/>
						{/* === Customer Portal (spec pivot #159 — magic-link only) === */}
						{/* /c/activate?token=... 是客戶從邀請信點進來的入口；
						    兌換成功直接跳 /c/surveys/:id（填寫頁），不再經過設密碼。 */}
						<Route
							path="/:lng/c/activate"
							element={<CustomerPortalActivate />}
						/>
						<Route
							path="/:lng/c/surveys"
							element={<CustomerPortalSurveysList />}
						/>
						<Route
							path="/:lng/c/surveys/:id"
							element={<CustomerPortalSurveyFill />}
						/>
						<Route
							path="/:lng/c/surveys/:id/view"
							element={<CustomerPortalSurveyView />}
						/>

					</Routes>
				</Suspense>
			</LanguageWrapper>
		</div>
	);
}

export default function AppWrapper() {
	return (
		<Router future={{ v7_startTransition: true }}>
			<App />
		</Router>
	);
}
